import React from "react";
import { Controller } from "react-hook-form";
import { TextField, MenuItem } from "@mui/material";

const timeZones = [
  {
    abbreviation: "ACST",
    offset: "UTC+09:30",
    description: "Australian Central Standard Time",
  },
  {
    abbreviation: "ADT",
    offset: "UTC−03:00",
    description: "Atlantic Daylight Time",
  },
  {
    abbreviation: "AEST",
    offset: "UTC+10:00",
    description: "Australian Eastern Standard Time",
  },
  {
    abbreviation: "AEDT",
    offset: "UTC+11:00",
    description: "Australian Eastern Daylight Time",
  },
  { abbreviation: "AFT", offset: "UTC+04:30", description: "Afghanistan Time" },
  {
    abbreviation: "AKST",
    offset: "UTC−09:00",
    description: "Alaska Standard Time",
  },
  { abbreviation: "AMT", offset: "UTC+04:00", description: "Armenia Time" },
  { abbreviation: "ART", offset: "UTC−03:00", description: "Argentina Time" },
  {
    abbreviation: "AST",
    offset: "UTC−04:00",
    description: "Atlantic Standard Time",
  },
  {
    abbreviation: "AST",
    offset: "UTC+03:00",
    description: "Arabia Standard Time",
  },
  {
    abbreviation: "AWST",
    offset: "UTC+08:00",
    description: "Australian Western Standard Time",
  },
  {
    abbreviation: "AZOT",
    offset: "UTC−01:00",
    description: "Azores Standard Time",
  },
  { abbreviation: "AZT", offset: "UTC+04:00", description: "Azerbaijan Time" },
  { abbreviation: "BRT", offset: "UTC−03:00", description: "Brazil Time" },
  {
    abbreviation: "BST",
    offset: "UTC+06:00",
    description: "Bangladesh Standard Time",
  },
  {
    abbreviation: "CAT",
    offset: "UTC+02:00",
    description: "Central Africa Time",
  },
  {
    abbreviation: "CET",
    offset: "UTC+01:00",
    description: "Central European Time",
  },
  {
    abbreviation: "CEST",
    offset: "UTC+02:00",
    description: "Central European Summer Time",
  },
  {
    abbreviation: "CHAST",
    offset: "UTC+12:45",
    description: "Chatham Standard Time",
  },
  {
    abbreviation: "CHADT",
    offset: "UTC+13:45",
    description: "Chatham Daylight Time",
  },
  {
    abbreviation: "CHOST",
    offset: "UTC+09:00",
    description: "Choibalsan Summer Time",
  },
  {
    abbreviation: "CHOT",
    offset: "UTC+08:00",
    description: "Choibalsan Standard Time",
  },
  { abbreviation: "CHUT", offset: "UTC+10:00", description: "Chuuk Time" },
  {
    abbreviation: "CLT",
    offset: "UTC−04:00",
    description: "Chile Standard Time",
  },
  {
    abbreviation: "CST",
    offset: "UTC−06:00",
    description: "Central Standard Time (US & Canada)",
  },
  {
    abbreviation: "CST",
    offset: "UTC+08:00",
    description: "China Standard Time",
  },
  { abbreviation: "CVT", offset: "UTC−01:00", description: "Cape Verde Time" },
  { abbreviation: "EAT", offset: "UTC+03:00", description: "East Africa Time" },
  {
    abbreviation: "EGT",
    offset: "UTC−01:00",
    description: "Eastern Greenland Time",
  },
  {
    abbreviation: "EET",
    offset: "UTC+02:00",
    description: "Eastern European Time",
  },
  {
    abbreviation: "EEST",
    offset: "UTC+03:00",
    description: "Eastern European Summer Time",
  },
  {
    abbreviation: "EST",
    offset: "UTC−05:00",
    description: "Eastern Standard Time (US & Canada)",
  },
  {
    abbreviation: "FET",
    offset: "UTC+03:00",
    description: "Further-eastern European Time",
  },
  { abbreviation: "FJT", offset: "UTC+12:00", description: "Fiji Time" },
  {
    abbreviation: "GET",
    offset: "UTC+04:00",
    description: "Georgia Standard Time",
  },
  {
    abbreviation: "GILT",
    offset: "UTC+12:00",
    description: "Gilbert Island Time",
  },
  {
    abbreviation: "GMT",
    offset: "UTC+00:00",
    description: "Greenwich Mean Time",
  },
  {
    abbreviation: "GST",
    offset: "UTC+04:00",
    description: "Gulf Standard Time",
  },
  {
    abbreviation: "HST",
    offset: "UTC−10:00",
    description: "Hawaii Standard Time",
  },
  { abbreviation: "ICT", offset: "UTC+07:00", description: "Indochina Time" },
  {
    abbreviation: "IDT",
    offset: "UTC+03:00",
    description: "Israel Daylight Time",
  },
  {
    abbreviation: "IRDT",
    offset: "UTC+04:30",
    description: "Iran Daylight Time",
  },
  { abbreviation: "IRKT", offset: "UTC+08:00", description: "Irkutsk Time" },
  {
    abbreviation: "IRST",
    offset: "UTC+03:30",
    description: "Iran Standard Time",
  },
  {
    abbreviation: "IST",
    offset: "UTC+05:30",
    description: "India Standard Time",
  },
  {
    abbreviation: "JST",
    offset: "UTC+09:00",
    description: "Japan Standard Time",
  },
  { abbreviation: "KOST", offset: "UTC+11:00", description: "Kosrae Time" },
  {
    abbreviation: "KRAT",
    offset: "UTC+07:00",
    description: "Krasnoyarsk Time",
  },
  {
    abbreviation: "KST",
    offset: "UTC+09:00",
    description: "Korea Standard Time",
  },
  {
    abbreviation: "LINT",
    offset: "UTC+14:00",
    description: "Line Islands Time",
  },
  { abbreviation: "MAGT", offset: "UTC+11:00", description: "Magadan Time" },
  {
    abbreviation: "MHT",
    offset: "UTC+12:00",
    description: "Marshall Islands Time",
  },
  { abbreviation: "MMT", offset: "UTC+06:30", description: "Myanmar Time" },
  {
    abbreviation: "MSK",
    offset: "UTC+03:00",
    description: "Moscow Standard Time",
  },
  {
    abbreviation: "MST",
    offset: "UTC−07:00",
    description: "Mountain Standard Time (US & Canada)",
  },
  {
    abbreviation: "NDT",
    offset: "UTC−02:30",
    description: "Newfoundland Daylight Time",
  },
  { abbreviation: "NPT", offset: "UTC+05:45", description: "Nepal Time" },
  { abbreviation: "NRT", offset: "UTC+12:00", description: "Nauru Time" },
  {
    abbreviation: "NST",
    offset: "UTC−03:30",
    description: "Newfoundland Standard Time",
  },
  {
    abbreviation: "NZDT",
    offset: "UTC+13:00",
    description: "New Zealand Daylight Time",
  },
  {
    abbreviation: "NZST",
    offset: "UTC+12:00",
    description: "New Zealand Standard Time",
  },
  { abbreviation: "OMST", offset: "UTC+06:00", description: "Omsk Time" },
  { abbreviation: "PETT", offset: "UTC+12:00", description: "Kamchatka Time" },
  {
    abbreviation: "PKT",
    offset: "UTC+05:00",
    description: "Pakistan Standard Time",
  },
  {
    abbreviation: "PONT",
    offset: "UTC+11:00",
    description: "Pohnpei Standard Time",
  },
  {
    abbreviation: "PST",
    offset: "UTC−08:00",
    description: "Pacific Standard Time (US & Canada)",
  },
  {
    abbreviation: "SAST",
    offset: "UTC+02:00",
    description: "South Africa Standard Time",
  },
  {
    abbreviation: "SBT",
    offset: "UTC+11:00",
    description: "Solomon Islands Time",
  },
  { abbreviation: "SGT", offset: "UTC+08:00", description: "Singapore Time" },
  {
    abbreviation: "SRET",
    offset: "UTC+11:00",
    description: "Srednekolymsk Time",
  },
  { abbreviation: "TKT", offset: "UTC+13:00", description: "Tokelau Time" },
  { abbreviation: "TOT", offset: "UTC+13:00", description: "Tonga Time" },
  { abbreviation: "TVT", offset: "UTC+12:00", description: "Tuvalu Time" },
  {
    abbreviation: "ULAST",
    offset: "UTC+09:00",
    description: "Ulaanbaatar Summer Time",
  },
  {
    abbreviation: "ULAT",
    offset: "UTC+08:00",
    description: "Ulaanbaatar Time",
  },
  {
    abbreviation: "UTC",
    offset: "UTC±00:00",
    description: "Coordinated Universal Time",
  },
  {
    abbreviation: "VLAT",
    offset: "UTC+10:00",
    description: "Vladivostok Time",
  },
  { abbreviation: "VUT", offset: "UTC+11:00", description: "Vanuatu Time" },
  {
    abbreviation: "WAKT",
    offset: "UTC+12:00",
    description: "Wake Island Time",
  },
  {
    abbreviation: "WAST",
    offset: "UTC+02:00",
    description: "West Africa Summer Time",
  },
  { abbreviation: "WAT", offset: "UTC+01:00", description: "West Africa Time" },
  {
    abbreviation: "WET",
    offset: "UTC+00:00",
    description: "Western European Time",
  },
  { abbreviation: "YAKT", offset: "UTC+09:00", description: "Yakutsk Time" },
  {
    abbreviation: "YEKT",
    offset: "UTC+05:00",
    description: "Yekaterinburg Time",
  },
];

const TimezoneSelect = ({ control, errors }) => {
  return (
    <Controller
      name="time_zone"
      control={control}
      defaultValue=""
      rules={{ required: "Time zone is required" }}
      render={({ field }) => (
        <TextField
          {...field}
          select
          fullWidth
          variant="standard"
          error={!!errors.time_zone}
          helperText={errors.time_zone?.message}
          InputProps={{ style: { fontSize: "12px" } }}
          sx={{ mb: 3 }}
        >
          {timeZones.map((zone, index) => (
            <MenuItem
              key={index}
              value={`${zone.abbreviation} (${zone.offset})`}
            >
              {`${zone.description} (${zone.offset})`}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};

export default TimezoneSelect;
